<template>
    <div class="shipping-rate">
        <label for="countries" class="form-label">
            Select your country
        </label>
        <select name="countries" id="countries" @change="selectCountry">
            <option :selected="true">Please Select a Country</option>
            <template v-for="(country,index) in this.shippingRate.countries">
                <option :value="country.name" :key="index">{{country.name}}</option>
            </template>
        </select>
        <div class="table--scrolling" v-if="selectedCountry != null">
            <table>
                <thead>
                    <tr>
                        <th>Shipped by</th>
                        <th>Delivery time</th>
                        <th>Price</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(shipper, index) in selectedCountry.CARRIER" :key="index">
                        <td> {{shipper.name}} ({{shipper.service_type}})</td>
                        <td> {{shipper.delivery_time}} </td>
                        <td> {{shipper.cost}} </td>
                    </tr>
                </tbody>


            </table>
        </div>
    </div>
</template>

<script>

export default {
    name: "shipping-rate",
    props: ['shippingRate'],

    data() {
        return {
            selectedCountry: null,
        }
    },

    methods: {
       selectCountry(e){
           this.shippingRate.countries.forEach(country => {
               if(country.name == e.target.value){
                   this.selectedCountry = country;
               }
           });
       }
    },

    created(){ 

        
        
    }

    
}
</script>

<style lang="scss" scoped>
    .shipping-rate{
        select{
            border-color: #616161;
        }
        table{
            th,td{
                padding: 8px;
                font-size: 11px;
            }

            tbody{
                th,td{
                    background-color: #f4f4f4;
                    border:none;
                    font-size:10px;
                    text-transform: uppercase;
                }
            }
        }

        @media only screen and (max-width: 767px){
            .table--scrolling{
                table{
                    margin-left: 0;
                }
            }
        }
    }
</style>